import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { selectGdprConsented, selectGdprLoaded } from '../store/gdpr/selectors/gdpr.selectors';
import { combineLatest } from 'rxjs';
import { ShowNotification } from '../store/notification/actions/notification.actions';

/**
 * GDPR Consent Guard
 *
 * Blocks access to enrichment routes unless GDPR consent has been accepted.
 * Redirects to /dashboard/settings where the admin can review and accept consent.
 * Dispatches a warning notification so the user understands why the redirect happened.
 *
 * Waits for the GDPR status to be loaded from the backend before evaluating.
 */
export const gdprConsentGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([store.select(selectGdprLoaded), store.select(selectGdprConsented)]).pipe(
    filter(([loaded]) => loaded),
    take(1),
    map(([, consented]) => {
      if (consented) {
        return true;
      }
      console.warn('GdprConsentGuard: GDPR consent not given, redirecting to settings');
      store.dispatch(
        ShowNotification({
          notification: {
            id: crypto.randomUUID(),
            severity: 'warning',
            title: 'GDPR consent required',
            summary:
              'Please review and accept the data enrichment consent before using Enrich & Discover.',
            icon: 'pi pi-exclamation-triangle',
            duration: 6000,
            dismissible: true,
            timestamp: new Date(),
          },
        }),
      );
      return router.createUrlTree(['/dashboard/settings']);
    }),
  );
};
